import { render, staticRenderFns } from "./KCHomePage.vue?vue&type=template&id=4f89255f&"
import script from "./KCHomePage.vue?vue&type=script&lang=js&"
export * from "./KCHomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports